var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 22",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.998 0c6.076 0 11 4.925 11 11s-4.924 11-11 11C4.923 22 0 17.075 0 11-.001 4.926 4.923 0 10.998 0zm-.004 9.074a1.1 1.1 0 00-1.091.973l-.008.128.005 6.05.006.13a1.1 1.1 0 002.186-.003l.006-.128-.004-6.05-.008-.13a1.1 1.1 0 00-1.093-.97h.001zm.005-4.124a1.376 1.376 0 10.003 2.753 1.376 1.376 0 00-.004-2.753H11z",
    fill: "currentColor"
  })));
};

export default SvgInfo;